module.exports = __webpack_public_path__ + "static/media/bench.1ac630bc.svg";